export default "__VITE_ASSET__57rpXD5B__"